<div class="empty-state" role="status" data-testid="empty-state">
  <p class="empty-state-message">{{ message() }}</p>
</div>
